import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createBusinessUnit,
  deleteBusinessUnit,
  fetchBusinessUnit,
  updateBusinessUnit,
} from "../../../services/businessinitService";

const initialState = {
  businessUnitData: [],
  loading: false,
  error: null,
};

export const fetchBusinessUnitAsync = createAsyncThunk(
  "businessunit/fetchBusinessUnit",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchBusinessUnit();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch");
    }
  }
);

export const createBusinessunitAsync = createAsyncThunk(
  "businessunit/createBusinessUnit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createBusinessUnit(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateBusinessunitAsync = createAsyncThunk(
  "businessunit/updateBusinessUnit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateBusinessUnit(id, data);
      return { id, data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteBusinessunitAsync = createAsyncThunk(
  "businessunit/deleteBusinessUnit",
  async (id, { rejectWithValue }) => {
    try {
      await deleteBusinessUnit(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const BusinessUnitSlice = createSlice({
  name: "businessunit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessUnitAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinessUnitAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.businessUnitData = action.payload;
      })
      .addCase(fetchBusinessUnitAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBusinessunitAsync.fulfilled, (state, action) => {
        state.businessUnitData.push(action.payload);
      })
      .addCase(updateBusinessunitAsync.fulfilled, (state, action) => {
        const index = state.businessUnitData.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.businessUnitData[index] = action.payload.data;
        }
      })
      .addCase(deleteBusinessunitAsync.fulfilled, (state, action) => {
        state.businessUnitData = state.businessUnitData.filter(
          (item) => item.id !== action.payload
        );
      });
  },
});

export default BusinessUnitSlice.reducer;
